import { useEffect } from 'react';
import { $memberApi } from '@stores/memberStores';

function useOwnerIdCheck() {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        $memberApi.teamMemberDataRequest();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
}

export default useOwnerIdCheck;
